import React from "react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
export function AuthorSection() {
  return <section className="bg-navy px-4 py-16 text-white md:py-24" data-id="element-69" data-mp="3m6piwd440xtp">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-70" data-mp="3qyqoxhaopsba">
        <div className="relative mx-auto w-full max-w-md" data-id="element-71" data-mp="3vymsxgjdtjqu">
          <img src={images.author} alt="Dr. Ryan Carter, creator of Shoulder Assessment Blueprint" className="w-full rounded-3xl object-cover" data-id="element-72" data-mp="3w06e9ljwakzh" />
          <div className="absolute -bottom-4 left-4 right-4 rounded-2xl bg-white px-5 py-3 text-center shadow-lg" data-id="element-73" data-mp="33bikf1l2ynab">
            <p className="font-display text-lg font-black uppercase text-ink" data-id="element-74" data-mp="38avhef5o1aqm">Dr. Ryan Carter</p>
            <p className="text-sm text-muted" data-id="element-75" data-mp="3d597q35h0rof">Creator of Shoulder Assessment Blueprint™</p>
          </div>
        </div>
        <div className="pt-4 lg:pt-0" data-id="element-76" data-mp="sh4ozk6qcwvp">
          <p className="font-display text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-77" data-mp="sg1uz3e42ebk">Meet the author</p>
          <h2 className="mt-2 text-balance font-display text-[28px] font-black uppercase leading-tight md:text-4xl" data-id="element-78" data-mp="247btmqgjzact">
            Why I created Shoulder Assessment Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-79" data-mp="1v5vhad66gy5y">
            <p data-id="element-80" data-mp="1q7ahufyr2iik">
              I believe that a structured assessment involves more than knowing individual examination procedures or
              memorizing lists of possible conditions.
            </p>
            <p data-id="element-81" data-mp="1ghheu3cobbpx">
              It also involves knowing how to organize information, recognize when findings require closer attention,
              and understand when additional evaluation may be necessary.
            </p>
            <p data-id="element-82" data-mp="17joziz6yc42j">
              Shoulder pain can present with a wide range of symptoms and functional limitations. The information
              gathered during an assessment needs to be interpreted in context, and no single examination finding can
              answer every clinical question.
            </p>
            <p className="font-semibold text-white" data-id="element-83" data-mp="ny5cji3sfe5p">That’s the focus of this educational collection.</p>
            <p data-id="element-84" data-mp="ssspcjpfik4g">
              I wanted to bring the initial assessment, screening considerations, physical examination, clinical
              reasoning, and case-based learning together in one organized resource.
            </p>
            <p data-id="element-85" data-mp="16m0hqdlc3jn7">
              My aim is to offer a practical educational reference that helps physiotherapists approach shoulder
              assessments with a clearer framework and a more deliberate reasoning process.
            </p>
            <p className="text-base text-brand-soft" data-id="element-86" data-mp="wvz1g7z835iu">
              This collection is intended to complement professional education and experience, not replace them.
            </p>
          </div>
          <div className="mt-8" data-id="element-87" data-mp="1pkmmc2g27svv">
            <CtaButton onDark label="Explore the complete blueprint" sub="One-time payment of $27 · Instant access" data-id="element-88" data-mp="1pjl7rnzu4o9e" />
          </div>
        </div>
      </div>
    </section>;
}